// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"231":"211773f56c83351ad5c7","589":"07ba842b8fdca85236e2","610":"11b291122cfccb84d075","678":"ba0f7f6b62ed9d2ec8a7","883":"85e54d4280ed2255a195","898":"a906db10b534dd0b2e35"}[chunkId] + ".js";
};